'use strict';

const SELECTOR = '.js-vimeo';

export function init() {
    const els = document.querySelectorAll(SELECTOR);

    if (!els.length) {
        return;
    }

    const tag = document.createElement('script');
    tag.src = 'https://players.brightcove.net/6160164157001/rZgFaaAhS_default/index.min.js';

    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    function videoJsLoaded(el) {
        if ('videojs' in window === false) {
            // Hack to wait for videojs to load
            setTimeout(() => {
                videoJsLoaded(el);
            }, 100);
            return;
        }

        if (!el.classList.contains('vjs-ready')) {
            const player = window.videojs(el);
            player.controls(true);
            player.muted(true);

            el.addEventListener('click', function() {
                el.closest('.js-inline-video').classList.add('playing');
                player.play();
            });
        }
    }

    /* eslint-disable */
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                videoJsLoaded(entry.target);
                // So the `click` event listener is only added once
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });
    /* eslint-enable */

    els.forEach(el => {
        observer.observe(el.closest('.js-inline-video'));
    });
}
